exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.app-tabs .el-tabs__active-bar.is-top {\r\n  width: 50% !important;\r\n  margin-left: -20px;\n}\n.app-tabs .el-tabs__nav.is-top {\r\n  width: 100%;\n}\n.app-tabs .el-tabs__item.is-top {\r\n  width: 50%;\r\n  text-align: center;\r\n  padding: 0 20px !important;\r\n  -webkit-box-sizing: border-box;\r\n          box-sizing: border-box;\n}\n.app-tabs .el-tabs__item.is-top:not(.is-active) {\r\n  color: #C4C4C4;\n}\n.search-input .el-input__inner {\r\n  border-radius: 4px;\n}\r\n", ""]);

// exports
